<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg507"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs511"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath521"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path519" /></clipPath></defs><g
     id="g513"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g515"><g
         id="g517"
         clip-path="url(#clipPath521)"><g
           id="g523"
           transform="translate(68.8462,504.501)"><path
             d="m 0,0 h -27.359 c -3.491,0 -6.321,-2.83 -6.321,-6.32 v -484.361 c 0,-3.491 2.83,-6.321 6.321,-6.321 H 0 c 3.491,0 6.32,2.83 6.32,6.321 V -6.32 C 6.32,-2.83 3.491,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path525" /></g><g
           id="g527"
           transform="translate(470.5127,504.501)"><path
             d="m 0,0 h -27.358 c -3.491,0 -6.321,-2.83 -6.321,-6.32 v -484.361 c 0,-3.491 2.83,-6.321 6.321,-6.321 H 0 c 3.491,0 6.321,2.83 6.321,6.321 V -6.32 C 6.321,-2.83 3.491,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path529" /></g><g
           id="g531"
           transform="translate(392.8413,201.75)"><path
             d="m 0,0 h -129.042 c -4.308,0 -7.799,-3.492 -7.799,-7.799 v -127.152 c 0,-4.307 3.491,-7.799 7.799,-7.799 H 0 c 4.308,0 7.799,3.492 7.799,7.799 V -7.799 C 7.799,-3.492 4.308,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path533" /></g><g
           id="g535"
           transform="translate(310.0703,201.75)"><path
             d="m 0,0 v -51.452 c 0,-2.65 2.148,-4.798 4.798,-4.798 h 26.904 c 2.65,0 4.798,2.148 4.798,4.798 V 0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path537" /></g><path
           d="m 75.166,236 h 361.667 v 40 H 75.166 Z"
           style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path539" /><path
           d="m 75.166,453 h 361.667 v 40 H 75.166 Z"
           style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path541" /><g
           id="g543"
           transform="translate(248.2007,418.75)"><path
             d="m 0,0 h -129.042 c -4.308,0 -7.799,-3.492 -7.799,-7.799 v -127.152 c 0,-4.307 3.491,-7.799 7.799,-7.799 H 0 c 4.308,0 7.799,3.492 7.799,7.799 V -7.799 C 7.799,-3.492 4.308,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path545" /></g><g
           id="g547"
           transform="translate(310.0703,384.5)"><path
             d="m 0,0 v -51.452 c 0,-2.65 2.148,-4.798 4.798,-4.798 h 26.904 c 2.65,0 4.798,2.148 4.798,4.798 V 0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path549" /></g><g
           id="g551"
           transform="translate(248.2007,167.5)"><path
             d="m 0,0 h -129.042 c -4.308,0 -7.799,-3.492 -7.799,-7.799 v -92.902 c 0,-4.307 3.491,-7.799 7.799,-7.799 L 0,-108.5 c 4.308,0 7.799,3.492 7.799,7.799 V -7.799 C 7.799,-3.492 4.308,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path553" /></g><g
           id="g555"
           transform="translate(165.4297,167.5)"><path
             d="m 0,0 v -51.452 c 0,-2.65 2.148,-4.798 4.798,-4.798 h 26.904 c 2.65,0 4.798,2.148 4.798,4.798 V 0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path557" /></g><g
           id="g559"
           transform="translate(165.4297,418.75)"><path
             d="m 0,0 v -51.452 c 0,-2.65 2.148,-4.798 4.798,-4.798 h 26.904 c 2.65,0 4.798,2.148 4.798,4.798 V 0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path561" /></g><g
           id="g563"
           transform="translate(273.5,19)"><path
             d="M 0,0 H 163.333 V 40 H -198.333 V 0 H -35"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path565" /></g><g
           id="g567"
           transform="translate(400.6406,347.75)"><path
             d="m 0,0 v 28.951 c 0,4.307 -3.492,7.799 -7.799,7.799 h -129.042 c -4.308,0 -7.8,-3.492 -7.8,-7.799 v -92.902 c 0,-4.307 3.492,-7.799 7.8,-7.799 H -7.799 c 4.307,0 7.799,3.492 7.799,7.799 L 0,-35"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path569" /></g></g></g></g></svg>
</template>
